import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { toast } from '@/hooks/use-toast';

interface LegacyRedirectProps {
  to: string;
  from: string;
  message?: string;
}

/**
 * Component for handling legacy route redirects with user-friendly toast notifications
 */
export const LegacyRedirect = ({ to, from, message }: LegacyRedirectProps) => {
  useEffect(() => {
    // Show toast notification about the redirect
    const defaultMessage = `This page has moved to a new location`;
    
    toast({
      title: "Page Moved",
      description: message || defaultMessage,
      duration: 5000,
    });

    // Log deprecation warning in console
    console.warn(`[Deprecated Route] ${from} has moved to ${to}`);
  }, [to, from, message]);

  return <Navigate to={to} replace />;
};
